import React from "react";
import { Button, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Usage from "../../controls/Usage";
import relativeTime from "../../util/relativeTime";
import { getGame } from "../gamemode_management/util/getGame";
import { unknownToError } from "@vortex/shared";
function nop() {
    // nop
}
function byAge(lhs, rhs) {
    return rhs.timestamp - lhs.timestamp;
}
function HistoryItem(props) {
    const { t, evt, onReverted, onError, stack, stackId } = props;
    const classes = ["history-event-line"];
    const canRevert = evt.reverted ? "invalid" : stack.canRevert(evt);
    if (canRevert === "invalid") {
        classes.push("history-event-invalid");
    }
    const onClick = React.useCallback(() => {
        onReverted(stackId, evt);
        stack
            .revert(evt)
            .catch((err) => onError(unknownToError(err), stackId, evt));
    }, []);
    const game = getGame(evt.gameId);
    const revertDescription = stack.describeRevert(evt);
    return (React.createElement("tr", { key: evt.id, className: classes.join(" ") },
        React.createElement("td", { className: "history-event-time" }, relativeTime(new Date(evt.timestamp), t)),
        React.createElement("td", { className: "history-event-game" }, game !== undefined ? (game.shortName ?? game.name) : null),
        React.createElement("td", { className: "history-event-description" }, stack.describe(evt)),
        React.createElement("td", { className: "history-event-revert" }, revertDescription ? (React.createElement(Button, { disabled: canRevert !== "yes", onClick: onClick }, revertDescription)) : null)));
}
function HistoryDialog(props) {
    const { t, events, onClose, onReverted, onError, stacks, stackToShow } = props;
    const stack = stacks[stackToShow];
    const sorted = (events ?? []).slice(0).sort(byAge);
    return (React.createElement(Modal, { id: "history-dialog", show: stack !== undefined, onHide: nop },
        React.createElement(Modal.Header, null,
            React.createElement("h2", null, t("Event history"))),
        React.createElement(Modal.Body, null,
            React.createElement("div", { className: "history-table-container" },
                React.createElement("table", null,
                    React.createElement("tbody", null, sorted.map((evt) => (React.createElement(HistoryItem, { t: t, key: evt.id, evt: evt, stack: stack, stackId: stackToShow, onReverted: onReverted, onError: onError })))))),
            React.createElement(Usage, { className: "history-usage", infoId: "event-history" }, t('Please note that this is not "Undo"! This screen allows you to revert ' +
                "specific actions but we make no promises that this actually returns " +
                "Vortex or your game to the state before that action. Not every " +
                "Action can be undone."))),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { onClick: onClose }, t("Close")))));
}
function mapPropsToState(state) {
    const { stackToShow } = state.session.history;
    return {
        stackToShow,
        events: stackToShow !== undefined
            ? state.persistent.history.historyStacks[stackToShow]
            : undefined,
    };
}
export default connect(mapPropsToState)(withTranslation(["common"])(HistoryDialog));
